import { State } from '../state.interface';
import * as Actions from '../actions';
import { assoc } from 'ramda';

export const setStringEditableReducer = (state: State, action: Actions.SetStringEditable) =>
  assoc('stringEditable', action.payload.stringEditable, state);
